export default "__VITE_ASSET__3c9a3b75__"